import { useTheme } from "@mui/material/styles";

// Hook that provides search-related styles
export const useSearchStyles = () => {
  const theme = useTheme();

  return {
    spaceSearchContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      marginRight: "10px",
      position: "relative" as const,
    },
    spaceSearchQueryContainer: {
      width: "100%",
    },
    queryTextField: {
      width: "640px",
    },
    slugFilterTextField: {
      width: "300px",
      alignSelf: "center",
      marginBottom: "1.5rem",
      marginRight: "0.25rem",
    },
    slugFilterDisclaimer: {
      right: "-100%",
      position: "absolute" as const,
    },
    titleButton: {
      padding: 0,
      width: "100%",
      justifyContent: "flex-start",
    },
    titleButtonInner: {
      width: "100%",
      justifyContent: "flex-start",
      textAlign: "left" as const,
    },
    deleteButton: {
      padding: 0,
      width: "100%",
      justifyContent: "flex-start",
    },
    tableButtonInner: {
      width: "100%",
      justifyContent: "center",
      padding: "4px",
      border: "1px solid grey",
    },
    redText: {
      color: theme.palette.error.main,
    },
    whiteText: {
      color: "white",
    },
    hidePreviewButton: {
      position: "absolute" as const,
      top: "0",
      right: "0",
      minWidth: "40px",
    },
    previewFrame: {
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
    previewFrameContainer: {
      flexBasis: "0px",
      position: "sticky" as const,
      top: "80px",
      height: "550px",
      background: theme.palette.background.paper,
      marginLeft: "10px",
      borderRadius: "4px",
      transition: "flex-basis 0.3s",
      boxShadow:
        "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    },
    absoluteSpinner: {
      position: "absolute" as const,
      marginLeft: "auto",
      marginRight: "auto",
      left: 0,
      right: 0,
      top: "100px",
      textAlign: "center" as const,
    },
    dialogInner: {
      paddingTop: "1.5rem",
    },
    deleteDisclaimer: {
      fontSize: "0.75rem",
      backgroundColor: theme.palette.background.default,
      borderRadius: "5px",
      padding: ".25rem 0.5rem",
    },
    numberInputContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "50%",
      margin: "4px 0px",
    },
    numberInput: {
      width: "80px",
    },
    editTemplateTextField: {
      width: "300px",
      alignSelf: "center",
      marginBottom: "1.5rem",
      marginRight: "0.25rem",
    },
    searchFilterButton: {
      color: theme.palette.text.primary,
      textTransform: "none" as const,
    },
    rankingCaretAndCancel: {
      fontSize: "10px",
      marginLeft: "3px",
    },
    iframeContainer: {
      height: "100%",
      minWidth: "100%",
    },
    contentLibraryTable: {
      tableLayout: "fixed" as const,
      borderCollapse: "collapse" as const,
      "& td": {
        wordBreak: "break-word",
      },
    },
    selectionBanner: {
      backgroundColor: theme.palette.action.selected,
      "& td": {
        padding: "8px 16px",
      },
    },
  };
};

// For backward compatibility
const useStyles = useSearchStyles;
export default useStyles;
